import React, { useState } from "react";
import "./CreateNewsPopup.css";

function CreateNewsPopup({ isOpen, onClose, onSubmit }) {
  const [formData, setFormData] = useState({
    title: "",
    content: "",
    images: [],
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateImages = (images) => {
    const maxSize = 5 * 1024 * 1024; // 5MB
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];

    for (const image of images) {
      if (image.size > maxSize) {
        throw new Error(
          `Изображение ${image.name} превышает допустимый размер 5MB`
        );
      }
      if (!allowedTypes.includes(image.type)) {
        throw new Error(`Формат файла ${image.name} не поддерживается`);
      }
    }
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    try {
      validateImages(files);
      setFormData((prev) => ({
        ...prev,
        images: files,
      }));
      setError(null);
    } catch (error) {
      setError(error.message);
      e.target.value = ""; // Очищаем input
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      await onSubmit(formData);
      setFormData({ title: "", content: "", images: [] });
    } catch (error) {
      console.error("Ошибка при отправке формы:", error);
      setError(error.message || "Произошла ошибка при создании новости");
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="create-news-popup" onClick={(e) => e.stopPropagation()}>
        {isLoading && (
          <div className="create-news-popup__loader">
            <div className="loader"></div>
          </div>
        )}
        <h3 className="create-news-popup__title">Создание новости</h3>
        <form onSubmit={handleSubmit} className="create-news-popup__form">
          <div className="create-news-popup__field">
            <label>Заголовок</label>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              required
              minLength={1}
              maxLength={100}
            />
          </div>

          <div className="create-news-popup__field">
            <label>Текст новости</label>
            <textarea
              name="content"
              value={formData.content}
              onChange={handleInputChange}
              required
              minLength={1}
              maxLength={5000}
            />
          </div>

          <div className="create-news-popup__field">
            <label>Изображения</label>
            <input
              type="file"
              multiple
              accept=".jpg,.jpeg,.png"
              onChange={handleImageChange}
              required
            />
            <small className="create-news-popup__hint">
              Поддерживаемые форматы: JPG, JPEG, PNG
            </small>
          </div>

          {error && <div className="create-news-popup__error">{error}</div>}

          <div className="create-news-popup__buttons">
            <button
              type="submit"
              className="create-news-popup__submit"
              disabled={isLoading}
            >
              {isLoading ? "Создание..." : "Создать"}
            </button>
            <button
              type="button"
              onClick={onClose}
              className="create-news-popup__cancel"
              disabled={isLoading}
            >
              Отмена
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateNewsPopup;
